import { LoadingOutlined } from '@ant-design/icons';
import { Button, Colors, Flex } from '@revenuemarket/cds';
import { ArrowDown, ArrowUp } from '@revenuemarket/ui';

import InfoItem from '../../InfoItem';

interface Props {
  orderUpDisable: boolean;
  orderDownDisable: boolean;
  isLoading: boolean;
  orderPosition: string;
  onArrowUpClick: () => void;
  onArrowDownClick: () => void;
}

const OrderChangeSection: React.FC<Props> = ({
  orderDownDisable,
  orderUpDisable,
  orderPosition,
  onArrowUpClick,
  onArrowDownClick,
  isLoading,
}) => {
  return (
    <InfoItem
      title="순서 변경"
      description={
        <Flex align="center" gap={4}>
          <Button
            disable={orderUpDisable}
            onClick={() => {
              onArrowUpClick();
            }}
            icon={
              isLoading && orderPosition === 'up' ? (
                <LoadingOutlined style={{ color: Colors.grayOpacity36, fontSize: 18 }} />
              ) : (
                <ArrowUp fill={orderUpDisable ? Colors.grayOpacity22 : Colors.gray700} />
              )
            }
          />
          <Button
            disable={orderDownDisable}
            onClick={() => {
              onArrowDownClick();
            }}
            icon={
              isLoading && orderPosition === 'down' ? (
                <LoadingOutlined style={{ color: Colors.grayOpacity36, fontSize: 18 }} />
              ) : (
                <ArrowDown fill={orderDownDisable ? Colors.grayOpacity22 : Colors.gray700} />
              )
            }
          />
        </Flex>
      }
    />
  );
};

export default OrderChangeSection;
